import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState, } from 'react';
import { cx, } from '../utils/ReactUtils.js';
import { getComponentPositionClass, } from './components.js';
export function Textbox({ value, onChange, onCommit, label = '', error, reserveErrorSpace = 0, disabled = false, className = '', position = 'normal', id, name, type = 'text', placeholder, autoComplete, inputMode, maxLength, }) {
    const [focused, setFocused] = useState(false);
    const autoId = useId();
    const inputId = id ?? `textbox-${autoId}`;
    const errorId = `${inputId}-error`;
    const isFloating = focused || value.length > 0;
    function commit() {
        if (typeof onCommit !== 'function') {
            return;
        }
        const next = onCommit(value);
        if (typeof next === 'string' && next !== value) {
            onChange(next);
        }
    }
    function handleKeyDown(e) {
        if (disabled) {
            return;
        }
        switch (e.key) {
            case 'Enter':
                commit();
                break;
            case 'Escape':
                e.currentTarget.blur();
                break;
        }
    }
    const errorMinHeight = reserveErrorSpace > 0
        ? { minHeight: `${reserveErrorSpace * 1.25}rem` }
        : undefined;
    const positionClass = getComponentPositionClass(position);
    let borderCss = 'border-tym-component-border-default hover:border-tym-component-border-hover';
    if (error) {
        borderCss = 'border-error';
    }
    else if (focused) {
        borderCss = 'border-tym-component-border-active';
    }
    return (_jsxs("div", { className: `w-full ${positionClass} ${className}`, children: [_jsxs("div", { className: "relative", children: [_jsx("label", { htmlFor: inputId, className: cx('absolute z-10 px-1 pointer-events-none', 'overflow-hidden text-ellipsis whitespace-nowrap', 'bg-white component-label-color', 'transition-all duration-200 ease-out', isFloating ? 'left-1 -top-2 text-xs' : 'left-2 right-2 top-2.5'), children: label }), _jsx("div", { className: cx('flex items-center px-3 py-2 border rounded-md bg-white', 'transition-colors duration-200 ease-out', borderCss, disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-text'), children: _jsx("input", { id: inputId, name: name, type: type, value: value, placeholder: placeholder, autoComplete: autoComplete, inputMode: inputMode, maxLength: maxLength, disabled: disabled, "aria-invalid": error ? true : undefined, "aria-describedby": error ? errorId : undefined, className: cx('flex-1 bg-transparent outline-none truncate', disabled ? 'cursor-not-allowed' : 'cursor-text'), onFocus: () => setFocused(true), onBlur: () => {
                                setFocused(false);
                                commit();
                            }, onChange: e => onChange(e.target.value), onKeyDown: handleKeyDown }) })] }), _jsx("p", { id: errorId, className: "input-error", style: errorMinHeight, children: error ?? '' })] }));
}
//# sourceMappingURL=Textbox.js.map